import { render, staticRenderFns } from "./CCBillComplaintFormLink.vue?vue&type=template&id=af4b9294&"
import script from "./CCBillComplaintFormLink.vue?vue&type=script&lang=js&"
export * from "./CCBillComplaintFormLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports